import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ListPreview from "./ListPreview";

export default function Lists() {
  const navigate = useNavigate();
  const lists = useSelector((state) => state.lists);
  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {lists
        .sort((a, b) => (moment(a.date).isBefore(moment(b.date)) ? 1 : -1))
        .map((l) => (
          <ListPreview list={l} onClick={() => navigate(`/lists/${l.id}`)} />
        ))}
      {/* <div>{JSON.stringify(lists, null, 2)}</div> */}
    </div>
  );
}
